export default __webpack_public_path__ + "static/bg-email-automation--mobile-e257db41ff7d70be9d50d46b8b6cf9f0.webp";